import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative bg-white border border-gray-200 dark:border-gray-700 dark:bg-black rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_3 = { class: "sticky top-0 bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg"
}
const _hoisted_6 = { class: "flex items-start" }
const _hoisted_7 = { class: "text-sm text-red-600 dark:text-red-400" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_10 = { class: "mb-6" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_12 = { class: "flex items-center justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, watch, computed } from 'vue';
import { useBrand } from '@/composables/brand/useBrand';

interface ProfileUpdateData {
  first_name: string;
  last_name: string;
  email: string;
  mobile: string;
  house_no: string;
  street: string;
  barangay: string;
  city: string;
}

interface UserProfile {
  first_name: string;
  last_name: string;
  email: string;
  mobile?: string;
  house_no?: string;
  street?: string;
  barangay?: string;
  city?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditProfileModal',
  props: {
    isOpen: { type: Boolean },
    userProfile: {},
    loading: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { brandColors } = useBrand();

const formData = ref<ProfileUpdateData>({
  first_name: '',
  last_name: '',
  email: '',
  mobile: '',
  house_no: '',
  street: '',
  barangay: '',
  city: ''
});

// Watch for user profile changes to populate form
watch(() => props.userProfile, (newProfile) => {
  if (newProfile) {
    formData.value = {
      first_name: newProfile.first_name || '',
      last_name: newProfile.last_name || '',
      email: newProfile.email || '',
      mobile: newProfile.mobile || '',
      house_no: newProfile.house_no || '',
      street: newProfile.street || '',
      barangay: newProfile.barangay || '',
      city: newProfile.city || ''
    };
  }
}, { immediate: true });

const validationError = ref<string | null>(null);

const hasValidationError = computed(() => !!validationError.value);

function handleSubmit() {
  validationError.value = null;

  if (!formData.value.mobile || !formData.value.city) {
    validationError.value = 'Mobile Number and City are required.';
    return;
  }

  emit('submit', formData.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center mr-3",
                        style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary + '20' })
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                          class: "w-5 h-5",
                          style: _normalizeStyle({ color: _unref(brandColors).primary })
                        }, _cache[12] || (_cache[12] = [
                          _createElementVNode("path", { d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" }, null, -1),
                          _createElementVNode("path", { d: "M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" }, null, -1)
                        ]), 4))
                      ], 4),
                      _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Edit Profile ", -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[14] || (_cache[14] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                    class: "px-6 py-4"
                  }, [
                    (_ctx.error || validationError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _cache[15] || (_cache[15] = _createElementVNode("svg", {
                              class: "w-5 h-5 text-red-600 dark:text-red-400 mt-0.5 mr-3 flex-shrink-0",
                              fill: "currentColor",
                              viewBox: "0 0 20 20"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                "clip-rule": "evenodd"
                              })
                            ], -1)),
                            _createElementVNode("p", _hoisted_7, _toDisplayString(validationError.value || _ctx.error), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4" }, "Personal Information", -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", null, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", {
                            for: "first_name",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" First Name "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "first_name",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.first_name) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white transition-colors",
                            style: _normalizeStyle({ 
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      })
                          }, null, 4), [
                            [_vModelText, formData.value.first_name]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", {
                            for: "last_name",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Last Name "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "last_name",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.last_name) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white transition-colors",
                            style: _normalizeStyle({ 
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      })
                          }, null, 4), [
                            [_vModelText, formData.value.last_name]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", {
                            for: "email",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Email "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "email",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.email) = $event)),
                            type: "email",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white transition-colors",
                            style: _normalizeStyle({ 
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      })
                          }, null, 4), [
                            [_vModelText, formData.value.email]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", {
                            for: "mobile",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Mobile Number "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "mobile",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.mobile) = $event)),
                            type: "text",
                            required: "",
                            onInput: _cache[5] || (_cache[5] = ($event: any) => (formData.value.mobile = formData.value.mobile.replace(/[^0-9]/g, ''))),
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white transition-colors",
                            style: _normalizeStyle({ 
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      })
                          }, null, 36), [
                            [_vModelText, formData.value.mobile]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4" }, "Address", -1)),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("label", {
                            for: "house_no",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, " House No. ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "house_no",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.house_no) = $event)),
                            type: "text",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white transition-colors",
                            style: _normalizeStyle({
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      })
                          }, null, 4), [
                            [_vModelText, formData.value.house_no]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", {
                            for: "street",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, " Street ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "street",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.street) = $event)),
                            type: "text",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white transition-colors",
                            style: _normalizeStyle({
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      })
                          }, null, 4), [
                            [_vModelText, formData.value.street]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", {
                            for: "barangay",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, " Barangay ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "barangay",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.barangay) = $event)),
                            type: "text",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white transition-colors",
                            style: _normalizeStyle({
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      })
                          }, null, 4), [
                            [_vModelText, formData.value.barangay]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", {
                            for: "city",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" City "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "city",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.city) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white transition-colors",
                            style: _normalizeStyle({
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      })
                          }, null, 4), [
                            [_vModelText, formData.value.city]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close'))),
                        disabled: _ctx.loading,
                        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                      }, " Cancel ", 8, _hoisted_13),
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: _ctx.loading,
                        class: "px-4 py-2 text-white rounded-lg transition-all duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
                        style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                      }, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[26] || (_cache[26] = [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }, null, -1),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Saving...' : 'Save Changes'), 1)
                      ], 12, _hoisted_14)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})